import React from 'react';
import { PenTool, Wrench, ShieldCheck, ArrowUpRight } from 'lucide-react';

const SERVICES = [
  {
    icon: PenTool,
    n: '01',
    title: 'Design',
    body: 'From napkin sketch to print-ready artwork. Our in-house design team preps files that install right the first time — bleeds, seam maps, panel breaks, color proofs.',
    tags: ['Print-ready files', 'Seam mapping', 'Color proofs'],
    img: 'https://static.wixstatic.com/media/88b789_0e1d8120e2fb4481ae6d68340f045a08~mv2.jpg/v1/fill/w_337,h_406,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/88b789_0e1d8120e2fb4481ae6d68340f045a08~mv2.jpg',
  },
  {
    icon: Wrench,
    n: '02',
    title: 'Install',
    body: 'Fleet graphics, color-change wraps, livery kits, wall graphics, floor graphics, PPF — nearly any paintable surface. Certified installers, 3M/Avery-approved technique.',
    tags: ['Fleet & livery', 'Color change', 'Wall / floor / window'],
    img: 'https://images.pexels.com/photos/10126663/pexels-photo-10126663.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    icon: ShieldCheck,
    n: '03',
    title: 'Care',
    body: 'Extend the life of every wrap with ceramic coating, exterior/interior detailing, and warranty inspections. We stand behind every install.',
    tags: ['Ceramic coat', 'Detailing', 'Warranty support'],
    img: 'https://images.unsplash.com/photo-1646531840695-62810bcd1171?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxjYXIlMjB3cmFwJTIwaW5zdGFsbGF0aW9ufGVufDB8fHx8MTc4NTgwMDYyNnww&ixlib=rb-4.1.0&q=85',
  },
];

export default function Services() {
  return (
    <section id="services" className="relative py-24 lg:py-32 border-b mi-line">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <div className="mi-eyebrow mb-3">// WHAT WE DO</div>
            <h2 className="mi-headline text-5xl md:text-6xl lg:text-7xl">
              Three services.<br />
              <span className="text-[#E63946]">One install partner.</span>
            </h2>
          </div>
          <p className="text-white/70 max-w-md leading-relaxed">
            Whether you're a print shop needing installers or a fleet operator needing turnkey wraps —
            we plug into your workflow so your brand stays on your invoice.
          </p>
        </div>

        <div className="grid md:grid-cols-3 border mi-line-strong">
          {SERVICES.map((s, i) => (
            <div
              key={s.title}
              className={`relative group p-8 lg:p-10 mi-card ${
                i < 2 ? 'md:border-r mi-line-strong' : ''
              }`}
            >
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-40 transition-opacity duration-500 bg-cover bg-center"
                style={{ backgroundImage: `url(${s.img})` }}
              />
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black" />

              <div className="relative">
                <div className="flex items-start justify-between mb-8">
                  <s.icon className="w-8 h-8 text-[#E63946]" strokeWidth={1.5} />
                  <span className="font-mono-data text-xs text-white/40">{s.n}</span>
                </div>
                <h3 className="mi-headline text-4xl mb-4">{s.title}</h3>
                <p className="text-white/70 text-sm leading-relaxed mb-6">{s.body}</p>
                <div className="flex flex-wrap gap-2 mb-8">
                  {s.tags.map((t) => (
                    <span key={t} className="mi-tag text-[10px]">{t}</span>
                  ))}
                </div>
                <a href="#quote" className="inline-flex items-center gap-2 text-sm font-semibold text-white group-hover:text-[#E63946] transition-colors">
                  Start a project <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
